import Proptypes from 'prop-types';
import React, { useCallback } from 'react';

import { RiBold } from 'react-icons/ri';

import NewDropDown from './NewDropDown';

export default function FontWeightFormatter({ editor, tooltipText, value, ...props }) {
  const handleClickOption = useCallback(fontWeight => editor.commands.setFontWeight(value === fontWeight ? null : fontWeight), [editor, value])

  return <NewDropDown
    options={WEIGHTS}
    onClickOption={handleClickOption}
    tooltipText={tooltipText}
    icon={RiBold} {...props}
    name='fontWeight'
    editor={editor}
    value={value}
  />
}

const WEIGHTS = [
  { value: 'thin', label: 'Thin (100)' },
  { value: 'extralight', label: 'Extra light (200)' },
  { value: 'light', label: 'Light (300)' },
  { value: 'normal', label: 'Normal (400)' },
  { value: 'medium', label: 'Medium (500)' },
  { value: 'semibold', label: 'Semi bold (600)' },
  { value: 'bold', label: 'Bold (700)' },
  { value: 'extrabold', label: 'Extra bold (800)' },
  { value: 'black', label: 'Black (900)' },
]

FontWeightFormatter.propTypes = {
  editor: Proptypes.object,
  tooltipText: Proptypes.string,
}
